module.exports = __webpack_public_path__ + "img/night-event.55adc6c9.png";